var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSaitama50(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "450pt",
    height: "325pt",
    viewBox: "0 0 450 325",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,65.490196%,14.901961%)",
      fillOpacity: 1
    },
    d: "M 299 176.84375 C 299 197.375 299.761719 230.832031 314.96875 230.832031 C 330.175781 230.832031 347.667969 193.574219 347.667969 173.042969 C 347.667969 152.511719 343.105469 139.582031 327.136719 139.582031 C 311.167969 139.582031 299 156.3125 299 176.84375 Z M 153 176.84375 C 153 197.375 152.238281 230.832031 137.03125 230.832031 C 121.824219 230.832031 104.332031 193.574219 104.332031 173.042969 C 104.332031 152.511719 108.894531 139.582031 124.863281 139.582031 C 140.832031 139.582031 153 156.3125 153 176.84375 Z M 153 176.84375 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.607843%,80.784314%,18.431373%)",
      fillOpacity: 1
    },
    d: "M 226 2.707031 C 167.449219 2.707031 119.542969 53.65625 119.542969 117.53125 C 119.542969 158.59375 133.988281 243.761719 149.957031 268.855469 C 165.925781 293.1875 205.46875 322.082031 226 322.082031 C 246.53125 322.082031 286.074219 293.1875 302.042969 268.855469 C 318.011719 243.761719 332.457031 158.59375 332.457031 117.53125 C 332.457031 53.65625 284.550781 2.707031 226 2.707031 Z M 226 2.707031 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,87.843137%,69.803922%)",
      fillOpacity: 1
    },
    d: "M 294.4375 64.300781 C 294.4375 49.855469 282.269531 36.925781 266.300781 33.886719 C 263.261719 33.125 256.417969 32.363281 256.417969 39.96875 C 256.417969 54.417969 268.582031 67.34375 284.550781 70.386719 C 287.59375 71.144531 294.4375 71.90625 294.4375 64.300781 Z M 294.4375 64.300781 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 309.644531 156.3125 C 309.644531 146.425781 274.667969 146.425781 274.667969 146.425781 C 274.667969 146.425781 248.8125 147.1875 248.8125 166.199219 C 248.8125 179.886719 270.105469 185.207031 282.269531 185.207031 C 295.957031 185.207031 309.644531 175.324219 309.644531 156.3125 Z M 309.644531 156.3125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(14.901961%,19.607843%,21.960784%)",
      fillOpacity: 1
    },
    d: "M 279.230469 154.792969 C 275.03125 154.792969 271.625 158.195312 271.625 162.394531 C 271.625 166.59375 275.03125 170 279.230469 170 C 283.429688 170 286.832031 166.59375 286.832031 162.394531 C 286.832031 158.195312 283.429688 154.792969 279.230469 154.792969 Z M 279.230469 154.792969 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,42.745098%,0%)",
      fillOpacity: 1
    },
    d: "M 248.8125 246.042969 C 248.8125 246.042969 231.324219 246.042969 222.957031 246.042969 C 217.636719 246.042969 214.59375 249.84375 214.59375 253.644531 C 214.59375 257.449219 218.394531 261.25 227.519531 261.25 C 240.449219 261.25 248.8125 246.042969 248.8125 246.042969 Z M 248.8125 246.042969 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,42.745098%,0%)",
      fillOpacity: 1
    },
    d: "M 213.074219 257.449219 C 208.511719 253.644531 210.792969 246.042969 216.875 246.042969 L 229.042969 246.042969 C 234.363281 246.042969 237.40625 249.84375 237.40625 253.644531 C 237.40625 257.449219 233.605469 261.25 224.480469 261.25 C 220.675781 261.25 216.875 259.730469 213.074219 257.449219 Z M 213.074219 257.449219 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,56.862745%,0%)",
      fillOpacity: 1
    },
    d: "M 203.1875 131.980469 L 172.769531 131.980469 C 168.207031 131.980469 165.167969 128.9375 165.167969 124.375 C 165.167969 119.8125 168.207031 116.769531 172.769531 116.769531 L 203.1875 116.769531 C 207.75 116.769531 210.792969 119.8125 210.792969 124.375 C 210.792969 128.9375 207.75 131.980469 203.1875 131.980469 Z M 286.832031 131.980469 L 256.417969 131.980469 C 251.855469 131.980469 248.8125 128.9375 248.8125 124.375 C 248.8125 119.8125 251.855469 116.769531 256.417969 116.769531 L 286.832031 116.769531 C 291.394531 116.769531 294.4375 119.8125 294.4375 124.375 C 294.4375 128.9375 291.394531 131.980469 286.832031 131.980469 Z M 196.34375 147.1875 L 186.457031 147.1875 L 186.457031 163.917969 L 203.1875 163.917969 L 203.1875 208.019531 L 218.394531 208.019531 L 218.394531 169.238281 C 218.394531 157.074219 208.511719 147.1875 196.34375 147.1875 Z M 196.34375 147.1875 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 149.957031 156.3125 C 149.957031 146.425781 184.9375 146.425781 184.9375 146.425781 C 184.9375 146.425781 210.792969 146.425781 210.792969 165.4375 C 210.792969 179.125 189.5 184.449219 177.332031 184.449219 C 163.644531 185.207031 149.957031 175.324219 149.957031 156.3125 Z M 149.957031 156.3125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(14.901961%,19.607843%,21.960784%)",
      fillOpacity: 1
    },
    d: "M 180.375 154.792969 C 176.175781 154.792969 172.769531 158.195312 172.769531 162.394531 C 172.769531 166.59375 176.175781 170 180.375 170 C 184.574219 170 187.980469 166.59375 187.980469 162.394531 C 187.980469 158.195312 184.574219 154.792969 180.375 154.792969 Z M 180.375 154.792969 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,56.862745%,0%)",
      fillOpacity: 1
    },
    d: "M 226 230.832031 C 213.074219 230.832031 203.1875 220.949219 203.1875 208.019531 C 203.1875 203.457031 206.230469 200.417969 210.792969 200.417969 C 215.355469 200.417969 218.394531 203.457031 218.394531 208.019531 C 218.394531 212.582031 221.4375 215.625 226 215.625 C 230.5625 215.625 233.605469 218.667969 233.605469 223.230469 C 233.605469 227.792969 230.5625 230.832031 226 230.832031 Z M 226 230.832031 "
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaitama50);
export default __webpack_public_path__ + "static/media/saitama-50.4381c2f5dd850bb91496a00a998272e0.svg";
export { ForwardRef as ReactComponent };